export const SOCIAL_ICONS = {
    instagram: {
        stroke: true,
        svg: '<rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r="0.9" fill="currentColor" stroke="none"/>',
    },
    youtube: {
        svg: '<path d="M21.6 7.2a2.5 2.5 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.5 2.5 0 0 0 2.4 7.2C2 8.8 2 12 2 12s0 3.2.4 4.8a2.5 2.5 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8c.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8ZM10 15V9l5.2 3L10 15Z"/>',
    },
    threads: {
        stroke: true,
        svg: '<circle cx="12" cy="12" r="3.1"/><path d="M15.1 12v1.4a2.3 2.3 0 0 0 4.6 0V12a7.7 7.7 0 1 0-3 6.1" stroke-linecap="round"/>',
    },
    bluesky: {
        svg: '<path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"/>',
    },
};
/** The icon as a complete <svg> string (for the Worker's HTML pages). */
export function socialIconSvg(key, size = 22) {
    const icon = SOCIAL_ICONS[key];
    if (!icon)
        return '';
    const paint = icon.stroke ? 'fill="none" stroke="currentColor" stroke-width="1.8"' : 'fill="currentColor"';
    return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" ${paint} aria-hidden="true" focusable="false">${icon.svg}</svg>`;
}
